import LearningResultAttendanceTable from './LearningResultAttendanceTable';

export default LearningResultAttendanceTable;
